export const PARAMS_ERRORS = {
  MANDATORY: {
    code: '0001',
    message: 'PARAMETER_MANDATORY',
  },
  FORMAT_NOT_VALID: {
    code: '0002',
    message: 'PARAMETER_FORMAT_NOT_VALID',
  },
};

export const SSP_ERRORS = {
  SSP_ERROR: {
    code: '0003',
    message: 'SSP_SERVICE_ERROR',
  },
  SSP_TIME_OUT: {
    code: '0004',
    message: 'SSP_TIME_OUT',
  },
  SSP_NO_AD_CONTENT: {
    code: '0005',
    message: 'SSP_NO_AD_CONTENT',
  },
  SSP_NO_ADUNIT: {
    code: '0006',
    message: 'SSP_NO_ADUNIT',
  },
  SSP_NO_MEDIATION: {
    code: '0007',
    message: 'SSP_NO_MEDIATION',
  },
  // TO INFORM PUBLISH WITH A GENERAL MESSAGE
  SSP_AD_EMPTY: {
    code: '0008',
    message: 'SSP_AD_EMPTY',
  },
};
